import Footer from "./common/Footer";
import "@google/model-viewer";
import { Link } from "react-router-dom";
// import Profile from "./common/Profile";
import level1Data from "../data/level1.json";
import HeaderDashboard from "./common/HeaderDashboard";
import { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import useAuth from "../hooks/useAuth";
import CryptoJS from "crypto-js";

let cacheClearPromise = null;

async function clearAllCachesOnHardRefresh() {
  if (cacheClearPromise) return cacheClearPromise;
  if (sessionStorage.getItem("hard-refresh") !== "1") return false;

  sessionStorage.removeItem("hard-refresh");
  cacheClearPromise = (async () => {
    if (!("caches" in window)) {
      console.warn("Cache Storage is unavailable; model downloads will bypass the browser cache.");
      return true;
    }

    const cacheNames = await window.caches.keys();
    const modelCacheNames = cacheNames.filter((name) =>
      name.startsWith("models")
    );
    await Promise.all(
      modelCacheNames.map((cacheName) => window.caches.delete(cacheName))
    );

    console.log("Cleared model caches:", modelCacheNames);
    return true;
  })();

  try {
    return await cacheClearPromise;
  } finally {
    cacheClearPromise = null;
  }
}

async function decryptModel(buffer) {
  const bytes = new Uint8Array(buffer);
  const iv = CryptoJS.lib.WordArray.create(bytes.slice(0, 16));
  const encrypted = CryptoJS.lib.WordArray.create(bytes.slice(16));
  const key = CryptoJS.enc.Utf8.parse(process.env.REACT_APP_MODEL_DECRYPT_KEY);
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: encrypted },
    key,
    {
      iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    }
  );
  const result = new Uint8Array(decrypted.sigBytes);

  for (let index = 0; index < decrypted.sigBytes; index += 1) {
    result[index] =
      (decrypted.words[index >>> 2] >>> (24 - (index % 4) * 8)) & 0xff;
  }

  return result.buffer;
}

const courses = ["head", "neck", "chest", "abdomen", "limbs"]
const scale = Math.min(
  window.innerWidth / 380,
  (window.innerHeight - 180) / 650
);

function CourseCard({ isOpen, info }) {
  return (
    <div className="course-card">
      <div
        className={
          "card p-0 border-0 rounded-3 position-relative h-100 " +
          (isOpen ? "bg-blue2" : "bg-gray4")
        }
      >
        <div className="card-body d-flex justify-content-center align-items-center">
          <div className="image">
            <img
              className="card-img-top img-fuild"
              src={`/icons/${info.slug}.svg`}
              alt={info.name}
            />
          </div>
        </div>
        {isOpen > 0 ? (
          <Link
            className="card-footer bg-blue1 border-0 rounded-bottom-3 text-center text-black text-decoration-none active stretched-link"
            to={`/${info.slug}?fromDashboard=true`}
          >
            <span className="fs-5 fw-bolder">{info.name}</span>
            <br />
            Open
          </Link>
        ) : (
          <div className="card-footer bg-gray3 border-0 rounded-bottom-3 text-center text-gray1">
            <span className="fs-5 fw-bolder">{info.name}</span>
            <br />
            Coming soon
          </div>
        )}
      </div>
    </div>
  )
}
function BodyParts() {
  const navigate = useNavigate();
  const { user } = useAuth();

  const [hovered, setHovered] = useState("");
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    text: ""
  });

  const parts = [
  {
    id: "head",
    label: "Head",
    src: "/icons/body/head.png",
    enabled: true,
    style: {
      left: "141px",
      top: "-3px",
      width: "99px"
    }
  },
  {
    id: "neck",
    label: "Neck",
    src: "/icons/body/neck.png",
    enabled: true,
    style: {
      left: "125px",
      top: "90px",
      width: "131px"
    }
  },
  {
    id: "chest",
    label: "Chest",
    src: "/icons/body/chest.png",
    enabled: true,
    style: {
      left: "105px",
      top: "144px",
      width: "171px",
       zIndex: 30
    }
  },
  {
    id: "abdomen",
    label: "Abdomen",
    src: "/icons/body/abdomen.png",
    enabled: true,
    style: {
      left: "109px",
      top: "288px",
      width: "162px",
       zIndex: 30
    }
  },
  {
    id: "upper-limbs",
    label: "Upper Limbs",
    src: "/icons/body/upper-limbs.png",
    enabled: true,
    style: {
      left: "3px",
      top: "146px",
      width: "374px",
      zIndex: 20
    }
  },
  {
    id: "lower-limbs",
    label: "Lower Limbs",
    src: "/icons/body/lower-limbs.png",
    enabled: true,
    style: {
      left: "104px",
      top: "395px",
      width: "173px",
      zIndex: 20
    }
  }
];

  const handleClick = (part) => {
    switch (part) {
      case "abdomen":
        navigate("/abdomen");
        break;

      case "chest":
        navigate("/chest");
        break;

      default:
        break;
    }
  };

  return (
    <>
     <div className="w-25">
                    <h2 className="fw-bold text-black">{user.firstName}'s Dashboard</h2>
                    <h5 className="fw-bolder text-gray2">{user.role}</h5>
                </div>
    <div
     /*  style={{
        position: "relative",
        width: "100%",
        maxWidth: "auto",
        height: "776px",
        justifyContent: "center",
        display: "flex",
        textAlign: "center"
      }} */
    //  className="d-flex flex-row pt-4 justify-content-between align-items-center"
     className="body-wrapper d-flex"
      style={{ top: "-60px"}}
    >
         <div
            /* style={{
              position: "absolute",
              inset: 0,
              left: 0,
              right: 0,
              margin: "0 auto",
              top: 0,
              width: "380px",
            }} */
          className="body-container"
          // style={{ transform: `scale(${scale})` }}
          >
              {/* Overlay Parts */}
              {parts.map((part) => (
                <img
                  key={part.id}
                  src={part.src}
                  alt={part.label}
                  onClick={() => part.enabled && handleClick(part.id)}
                  onMouseMove={(e) => {
                    if (!part.enabled) return;

                    setHovered(part.id);
                    setTooltip({
                      visible: true,
                      x: e.clientX,
                      y: e.clientY,
                      text: part.label
                    });
                  }}
                  onMouseLeave={() => {
                    setHovered("");
                    setTooltip({
                      visible: false,
                      x: 0,
                      y: 0,
                      text: ""
                    });
                  }}
                  style={{
                    position: "absolute",
                    ...part.style,
                    // opacity: hovered === part.id ? 0.55 : 0,
                    mixBlendMode: hovered === part.id ? "hard-light" : "",
                    transition: "opacity .2s",
                    cursor: part.enabled ? "pointer" : "default",
                    objectFit: "cover",
                    pointerEvents: part.enabled ? "auto" : "none"
                  }}
                />
              ))}
      </div>
    </div>
    </>
  );
}
function Dashboard() {
  const { user } = useAuth();
  const modelViewerRef = useRef(null);
  const fullBodyDetailRef = useRef(null);
  const modelObjectUrlsRef = useRef(new Set());
  const modelSwitchRequestRef = useRef(null);
  const isModelSwitchingRef = useRef(false);
  const cameraResetRequestRef = useRef(null);
  const initialCameraStateRef = useRef([]);
  const restoreModelAfterFailedSwitchRef = useRef(null);
  const navigate = useNavigate();
  const muscleModelSrc = "/icons/Abdominal_Muscules.glb";
  const [modelSources, setModelSources] = useState([
    muscleModelSrc,
    ""
  ]);
  const [activeModelIndex, setActiveModelIndex] = useState(0);
  const [isModelSwitching, setIsModelSwitching] = useState(false);
  const [isModelAnimating, setIsModelAnimating] = useState(false);
  const [modelSwitchError, setModelSwitchError] = useState("");
  const [modelLoadProgress, setModelLoadProgress] = useState(0);
  const [fullBodyMaterials, setFullBodyMaterials] = useState([]);
  const [isOrganMenuOpen, setIsOrganMenuOpen] = useState(false);
  const activeModelSrc = modelSources[activeModelIndex];
  const showFullBodyModel = activeModelIndex === 1;
  useEffect(() => () => {
    modelObjectUrlsRef.current.forEach((url) => URL.revokeObjectURL(url));
    modelObjectUrlsRef.current.clear();
  }, []);

  const saveInitialCameraState = (modelIndex, modelViewer) => {
    if (initialCameraStateRef.current[modelIndex]) return;

    initialCameraStateRef.current[modelIndex] = {
      orbit: modelViewer.cameraOrbit,
      target: modelViewer.cameraTarget,
      fieldOfView: modelViewer.fieldOfView,
    };
  };
  const restoreInitialCameraState = (modelIndex, modelViewer) => {
    const initialState = initialCameraStateRef.current[modelIndex];
    if (!initialState) {
      saveInitialCameraState(modelIndex, modelViewer);
      return;
    }

    modelViewer.cameraOrbit = initialState.orbit;
    modelViewer.cameraTarget = initialState.target;
    modelViewer.fieldOfView = initialState.fieldOfView;
    modelViewer.jumpCameraToGoal();
  };
  useEffect(() => {
    const modelViewer = modelViewerRef.current;
    if (!modelViewer) return undefined;

    const handleInitialModelLoad = () => {
      saveInitialCameraState(0, modelViewer);
    };
    if (modelViewer.loaded) {
      handleInitialModelLoad();
      return undefined;
    }

    modelViewer.addEventListener("load", handleInitialModelLoad, { once: true });
    return () => {
      modelViewer.removeEventListener("load", handleInitialModelLoad);
    };
  }, []);

  const loadFullBodyModel = async () => {
    const bypassCache = await clearAllCachesOnHardRefresh();
    const detailResponse = await fetch(
      `${process.env.REACT_APP_API_URL}/get-glb-model-detail`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          level1: "dashboard",
          level2: "anatomy-full-body",
        }),
      }
    );
    if (!detailResponse.ok) {
      throw new Error(`Failed to get full-body model details (${detailResponse.status}).`);
    }

    const detail = await detailResponse.json();
    if (!detail?.file_name || detail.file_name === "coming-soon") {
      throw new Error("The full-body model is not available.");
    }

    fullBodyDetailRef.current = detail;
    const modelName = detail.file_name.replace(/\.glb$/i, "");
    let cache = null;
    let cached = null;

    try {
      if ("caches" in window) {
        cache = await window.caches.open("models-v1");
        if (!bypassCache) cached = await cache.match(modelName);
      } else {
        console.warn("Model cache unavailable; downloading model without cache.");
      }
    } catch (error) {
      cache = null;
      console.warn("Could not access the model cache; downloading without cache.", error);
    }

    let blob = null;
    if (cached) {
      try {
        blob = await cached.blob();
      } catch (error) {
        console.warn("Could not read the cached model; downloading a fresh copy.", error);
        try {
          await cache?.delete(modelName);
        } catch (deleteError) {
          console.warn("Could not remove the unreadable cached model.", deleteError);
        }
        cache = null;
      }
    }

    if (!blob) {
      const urlResponse = await fetch(
        `${process.env.REACT_APP_API_URL}/model/${modelName}`,
        { cache: bypassCache ? "no-store" : "default" }
      );
      if (!urlResponse.ok) {
        throw new Error(`Failed to get full-body model URL (${urlResponse.status}).`);
      }

      const { url } = await urlResponse.json();
      const modelResponse = await fetch(url, {
        cache: bypassCache ? "no-store" : "default",
      });
      if (!modelResponse.ok) {
        throw new Error(`Failed to download full-body model (${modelResponse.status}).`);
      }

      const totalSize = Number(modelResponse.headers.get("Content-Length")) || 0;
      let encryptedBuffer;
      if (modelResponse.body) {
        const reader = modelResponse.body.getReader();
        const chunks = [];
        let received = 0;

        while (true) {
          const { done, value } = await reader.read();
          if (done) break;

          chunks.push(value);
          received += value.byteLength;
          if (totalSize) {
            setModelLoadProgress(0.8 * (received / totalSize));
          }
        }

        encryptedBuffer = await new Blob(chunks).arrayBuffer();
      } else {
        encryptedBuffer = await modelResponse.arrayBuffer();
      }

      const decryptedBuffer = await decryptModel(encryptedBuffer);
      blob = new Blob([decryptedBuffer], { type: "model/gltf-binary" });
    }

    setModelLoadProgress(0.8);
    const blobUrl = URL.createObjectURL(blob);
    modelObjectUrlsRef.current.add(blobUrl);

    if (!cached && cache) {
      cache
        .put(
          modelName,
          new Response(blob, {
            headers: {
              "Content-Type": "model/gltf-binary",
              "Content-Length": String(blob.size),
            },
          })
        )
        .then(() => console.log("Model cached:", modelName))
        .catch((error) => {
          if (error.name !== "AbortError") {
            console.warn("Could not cache the downloaded model.", error);
          }
        });
    }

    return blobUrl;
  };
  const handleModelSwitch = async (modelIndex) => {
    if (
      modelIndex === activeModelIndex
      || isModelSwitching
      || isModelSwitchingRef.current
    ) return;

    isModelSwitchingRef.current = true;
    if (modelIndex !== 1) setIsOrganMenuOpen(false);
    if (activeModelIndex === 1) setFullBodyMaterials([]);

    const request = {
      index: modelIndex,
      previousIndex: activeModelIndex,
      waitForSource: modelIndex === 1 && !modelSources[modelIndex],
      waitForLoad: true,
      targetSrc: modelSources[modelIndex] || null,
    };
    modelSwitchRequestRef.current = request;
    setModelSwitchError("");
    setModelLoadProgress(0);
    setIsModelSwitching(true);
    setIsModelAnimating(false);

    try {
      const nextModelSrc = modelSources[modelIndex]
        || (modelIndex === 0 ? muscleModelSrc : await loadFullBodyModel());
      if (modelSwitchRequestRef.current !== request) return;

      request.targetSrc = nextModelSrc;
      request.waitForSource = false;
      setModelSources((sources) =>
        sources.map((source, index) =>
          index === modelIndex ? nextModelSrc : source
        )
      );
      setActiveModelIndex(modelIndex);
    } catch (error) {
      console.error("Failed to prepare dashboard model:", error);
      restoreModelAfterFailedSwitch(request);
      setModelSwitchError(
        "The model could not be loaded. Check the model file and network connection."
      );
    }
  };
  const markModelReady = (
    modelIndex,
    modelViewer,
    animateSwitch = true,
    expectedRequest = null
  ) => {
    if (
      expectedRequest
      && modelSwitchRequestRef.current !== expectedRequest
    ) return;
    if (modelSwitchRequestRef.current?.waitForLoad) return;
    if (!modelViewer.loaded) return;

    const request = modelSwitchRequestRef.current;
    if (request && request.index !== modelIndex) return;
    if (!initialCameraStateRef.current[modelIndex]) {
      saveInitialCameraState(modelIndex, modelViewer);
    } else if (request && cameraResetRequestRef.current !== request) {
      restoreInitialCameraState(modelIndex, modelViewer);
      cameraResetRequestRef.current = request;
    }

    if (modelIndex === 1 && modelViewer.model?.materials) {
      const dbMaterials = fullBodyDetailRef.current?.materials || [];
      const dbMaterialsByName = new Map(
        dbMaterials.map((material) => [material.originalName, material])
      );
      const entries = modelViewer.model.materials.map((material, index) => {
        const name = material.name || `Part ${index + 1}`;
        const dbMaterial = dbMaterialsByName.get(name);
        const label = dbMaterial?.displayName || name
          .replace(/^adskMat/i, "")
          .replace(/([a-z0-9])([A-Z])/g, "$1 $2")
          .replace(/[_-]/g, " ")
          .replace(/\s+/g, " ")
          .trim()
          .replace(/\b\w/g, (letter) => letter.toUpperCase());

        return {
          material,
          name,
          label,
          order: dbMaterial?.order ?? Number.MAX_SAFE_INTEGER,
          visible: material.visible ?? true,
          baseColor: [
            ...(material.pbrMetallicRoughness?.baseColorFactor || [1, 1, 1, 1])
          ],
          alphaMode: material.getAlphaMode()
        };
      });
      entries.sort((left, right) => left.order - right.order);
      setFullBodyMaterials((currentMaterials) =>
        currentMaterials.length ? currentMaterials : entries
      );
    }

    setModelLoadProgress(1);
    if (animateSwitch) setIsModelAnimating(true);
  };
  const restoreModelAfterFailedSwitch = (request) => {
    if (modelSwitchRequestRef.current !== request) return;

    modelSwitchRequestRef.current = null;
    isModelSwitchingRef.current = false;
    setActiveModelIndex(request.previousIndex);
    if (request.index === 1 && !request.previousIndex) {
      setModelSources((sources) =>
        sources.map((source, index) => index === request.index ? "" : source)
      );
    }
    setIsModelSwitching(false);
    setIsModelAnimating(false);
  };
  restoreModelAfterFailedSwitchRef.current = restoreModelAfterFailedSwitch;
  const setOrganVisibility = (materialIndex, visible) => {
    const entry = fullBodyMaterials[materialIndex];
    if (!entry) return;

    const { material, baseColor, alphaMode } = entry;
    material.setAlphaMode(visible ? alphaMode : "BLEND");
    material.pbrMetallicRoughness.setBaseColorFactor([
      ...baseColor.slice(0, 3),
      visible ? baseColor[3] : 0
    ]);
    setFullBodyMaterials((materials) =>
      materials.map((item, index) =>
        index === materialIndex ? { ...item, visible } : item
      )
    );
  };
  const [tooltip, setTooltip] = useState({
    visible: false,
    x: 0,
    y: 0,
    text: ""
  });

  useEffect(() => {
    const modelViewer = modelViewerRef.current;
    if (!modelViewer) return undefined;

    const abortController = new AbortController();
    let materialNamesByPrimitive = [];
    const materialRoutes = {
      Muscules: "/abdomen",
      Extrinsic_Thoracic_Muscles: "/chest"
    };
    const materialLabels = {
      Muscules: "Abdomen",
      Extrinsic_Thoracic_Muscles: "Chest"
    };

    const loadMaterialNames = async () => {
      if (showFullBodyModel) {
        materialNamesByPrimitive = [];
        return;
      }

      try {
        const response = await fetch(activeModelSrc, {
          signal: abortController.signal
        });
        if (!response.ok) {
          throw new Error(`Failed to load model metadata (${response.status}).`);
        }

        const buffer = await response.arrayBuffer();
        const data = new DataView(buffer);
        if (data.getUint32(0, true) !== 0x46546c67) {
          throw new Error("The model asset is not a valid GLB file.");
        }

        const jsonChunkLength = data.getUint32(12, true);
        const jsonChunkType = data.getUint32(16, true);
        if (jsonChunkType !== 0x4e4f534a) {
          throw new Error("The GLB model does not contain a JSON metadata chunk.");
        }

        const gltf = JSON.parse(
          new TextDecoder().decode(new Uint8Array(buffer, 20, jsonChunkLength))
        );
        const materialNames = gltf.materials?.map((material) => material.name);
        materialNamesByPrimitive = gltf.meshes?.map((mesh) =>
          mesh.primitives.map((primitive) => materialNames?.[primitive.material])
        ) || [];
      } catch (error) {
        if (error.name !== "AbortError") {
          console.error("Failed to read model material metadata:", error);
        }
      }
    };
    loadMaterialNames();

    const getMaterialNameAtPoint = (event) => {
      if (!modelViewer.model) return null;

      const surface = modelViewer.surfaceFromPoint(
        event.clientX,
        event.clientY
      );
      if (!surface) return null;

      const [meshIndex, primitiveIndex] = surface
        .split(" ", 2)
        .map(Number);
      if (!Number.isInteger(meshIndex) || !Number.isInteger(primitiveIndex)) {
        return null;
      }

      return materialNamesByPrimitive[meshIndex]?.[primitiveIndex] || null;
    };

    const handlePointerMove = (event) => {
      if (showFullBodyModel || isModelSwitching) {
        modelViewer.style.cursor = "default";
        setTooltip({ visible: false, x: 0, y: 0, text: "" });
        return;
      }

      const materialName = getMaterialNameAtPoint(event);

      setTooltip({
        visible: Boolean(materialRoutes[materialName]),
        x: event.clientX,
        y: event.clientY,
        text: materialLabels[materialName] || ""
      });

      modelViewer.style.cursor = materialRoutes[materialName]
        ? "pointer"
        : "default";
    };

    const handleClick = (event) => {
      if (showFullBodyModel || isModelSwitching) return;

      const materialName = getMaterialNameAtPoint(event);
      const route = materialRoutes[materialName];
      if (route) navigate(route);
    };

    const handlePointerLeave = () => {
      modelViewer.style.cursor = "default";
      setTooltip({ visible: false, x: 0, y: 0, text: "" });
    };

    modelViewer.addEventListener("pointermove", handlePointerMove);
    modelViewer.addEventListener("click", handleClick);
    modelViewer.addEventListener("pointerleave", handlePointerLeave);

    return () => {
      abortController.abort();
      modelViewer.removeEventListener("pointermove", handlePointerMove);
      modelViewer.removeEventListener("click", handleClick);
      modelViewer.removeEventListener("pointerleave", handlePointerLeave);
    };
  }, [
    activeModelIndex,
    activeModelSrc,
    isModelSwitching,
    navigate,
    showFullBodyModel
  ]);

  useEffect(() => {
    if (!isModelSwitching || isModelAnimating) return undefined;

    const request = modelSwitchRequestRef.current;
    const modelViewer = modelViewerRef.current;
    if (!request || !modelViewer) return undefined;

    const handleError = (event) => {
      if (
        modelSwitchRequestRef.current !== request
        || request.waitForSource
        || modelViewer.getAttribute("src") !== request.targetSrc
      ) return;
      console.error("Failed to load dashboard model:", event.detail);
      restoreModelAfterFailedSwitchRef.current(request);
      setModelSwitchError(
        "The model could not be loaded. Check the model file and network connection."
      );
    };
    const handleProgress = (event) => {
      if (
        modelSwitchRequestRef.current !== request
        || request.waitForSource
        || modelViewer.getAttribute("src") !== request.targetSrc
      ) return;
      const modelProgress = event.detail.totalProgress;
      const progress = request.index === 1
        ? 0.8 + modelProgress * 0.2
        : modelProgress;
      setModelLoadProgress(Math.max(0, Math.min(progress, 1)));
    };
    const handleLoad = () => {
      if (
        modelSwitchRequestRef.current !== request
        || request.waitForSource
        || modelViewer.getAttribute("src") !== request.targetSrc
      ) return;
      request.waitForLoad = false;
      markModelReady(request.index, modelViewer, true, request);
    };

    const readinessInterval = window.setInterval(() => {
      markModelReady(request.index, modelViewer, true, request);
    }, 100);
    const timeoutId = window.setTimeout(() => {
      if (modelSwitchRequestRef.current !== request) return;
      if (modelViewer.loaded && !request.waitForLoad) return;

      console.error(`Timed out loading dashboard model: ${modelViewer.src}`);
      restoreModelAfterFailedSwitchRef.current(request);
      setModelSwitchError(
        "The model is taking too long to load. Check the model file and network connection."
      );
    }, 60000);

    modelViewer.addEventListener("error", handleError);
    modelViewer.addEventListener("load", handleLoad);
    modelViewer.addEventListener("progress", handleProgress);

    return () => {
      window.clearInterval(readinessInterval);
      window.clearTimeout(timeoutId);
      modelViewer.removeEventListener("error", handleError);
      modelViewer.removeEventListener("load", handleLoad);
      modelViewer.removeEventListener("progress", handleProgress);
    };
  }, [isModelAnimating, isModelSwitching]);

  useEffect(() => {
    if (!isModelSwitching || !isModelAnimating) return undefined;

    const request = modelSwitchRequestRef.current;
    if (!request) return undefined;

    const finishSwitch = () => {
      if (modelSwitchRequestRef.current !== request) return;
      const incomingModelIndex = request.index;
      setActiveModelIndex(incomingModelIndex);
      modelSwitchRequestRef.current = null;
      setIsModelAnimating(false);
      setModelSwitchError("");
      isModelSwitchingRef.current = false;
      setIsModelSwitching(false);
    };
    const motionDuration = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches ? 20 : 2500;
    const timeoutId = window.setTimeout(finishSwitch, motionDuration);

    return () => window.clearTimeout(timeoutId);
  }, [isModelAnimating, isModelSwitching]);

  return (
    <div className="w-100 h-100 bg-green5 overflow-hidden">
      <HeaderDashboard />
      {tooltip.visible && (
        <div
          role="tooltip"
          style={{
            position: "fixed",
            left: tooltip.x + 14,
            top: tooltip.y + 14,
            zIndex: 10,
            pointerEvents: "none",
            padding: "6px 10px",
            borderRadius: "4px",
            backgroundColor: "rgba(0, 0, 0, 0.8)",
            color: "#fff",
            fontSize: "0.875rem",
            whiteSpace: "nowrap"
          }}
        >
          {tooltip.text}
        </div>
      )}
      <main
        className="main-section body-main-section w-100 overflow-hidden bg-grey-light"
        style={{
          flex: 1,
          margin: 0,
          borderRadius: 0,
          minHeight: 0,
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: "0 2rem",
          position: "relative"
        }}
      >
        <button
          type="button"
          className="dashboard-model-switch"
          aria-label={`Switch to ${showFullBodyModel ? "Go to Dashboard" : "Switch to Virtual Full Body"}`}
          disabled={isModelSwitching}
          onClick={() => handleModelSwitch(showFullBodyModel ? 0 : 1)}
        >
          {!showFullBodyModel && (
            <span
            className="dashboard-model-switch-icon body-icon"
            role="img"
            aria-label="body grid"
          />
          )}
          {showFullBodyModel && (
          <span
            className="dashboard-model-switch-icon dashboard-model-grid-icon"
            role="img"
            aria-label="Dashboard grid"
          />
          )}
          {isModelSwitching
            ? "Switching model..."
            : showFullBodyModel
              ? "Go to Dashboard"
              : "Switch to Virtual Full Body"}
        </button>
        {/* <div className="dashboard-user-options">
          <div className="dashboard-user-card">
            <span className="dashboard-user-eyebrow">Welcome back</span>
            <h2 className="dashboard-user-name">{user.firstName}'s Dashboard</h2>
            <span className="dashboard-user-role">{user.role}</span>
          </div>
          <div className="dashboard-user-card dashboard-user-card-alt">
            <div className="dashboard-user-avatar" aria-hidden="true">
              {user.firstName?.charAt(0)?.toUpperCase() || "U"}
            </div>
            <div className="dashboard-user-card-alt-copy">
              <span className="dashboard-user-eyebrow">Good to see you</span>
              <h2 className="dashboard-user-name">{user.firstName}</h2>
              <span className="dashboard-user-role">{user.role}</span>
            </div>
          </div>
          <div className="dashboard-user-card dashboard-user-card-minimal">
            <span className="dashboard-user-minimal-mark" aria-hidden="true" />
              <div className="dashboard-user-card-alt-copy">
                <span className="dashboard-user-eyebrow">Your learning space</span>
                <h2 className="dashboard-user-name">{user.firstName}'s Dashboard</h2>
                <span className="dashboard-user-role">{user.role}</span>
              </div>
          </div>
        </div> */}
        <div
          className="model-object bg-grey-light"
          style={{
            width: "min(80%, 1000px)",
            height: "80%",
            maxHeight: "calc(100vh - 6rem)",
            margin: "0 auto",
            position: "relative",
            flex: "0 1 1000px",
            overflow: "hidden",
          }}
        >
          <div
            id={`dashboard-model-panel-${activeModelIndex}`}
            role="tabpanel"
            aria-label={
              activeModelIndex === 0
                ? "Go to Dashboard model"
                : "Virtual Full Body"
            }
            className={
              isModelAnimating
                ? "dashboard-model-slide dashboard-model-slide-enter"
                : "dashboard-model-slide dashboard-model-slide-active"
            }
          >
            <model-viewer
              ref={modelViewerRef}
              src={activeModelSrc || undefined}
              loading="eager"
              camera-controls={showFullBodyModel ? "" : undefined}
              disable-pan={showFullBodyModel ? "" : undefined}
              camera-orbit="90deg 90deg auto"
              interaction-prompt="none"
              className="model-viewer dashboard-model-viewer"
              style={{
                width: "100%",
                height: "100%",
                minHeight: 0,
                "--progress-bar-height": "0px",
                "--progress-bar-color": "transparent",
                background: "transparent"
              }}
            >
              <div slot="progress-bar" aria-hidden="true" />
            </model-viewer>
          </div>
          {showFullBodyModel && fullBodyMaterials.length > 0 && (
            <div className="dashboard-organ-menu">
              <button
                type="button"
                className="toggle-btn icon-btn"
                aria-label="Toggle organ menu"
                aria-expanded={isOrganMenuOpen}
                aria-controls="dashboard-organ-menu"
                onClick={() => setIsOrganMenuOpen((isOpen) => !isOpen)}
              >
                <span
                  className="material-symbols-outlined"
                  style={{ fontSize: "20px" }}
                  aria-hidden="true"
                >
                  menu
                </span>
              </button>
              <div
                id="dashboard-organ-menu"
                className={`model-overlay-buttons organ-menu${isOrganMenuOpen ? " open" : ""}`}
              >
                <div className="organ-menu-heading">
                  <span>Organs</span>
                  <span className="organ-menu-count">
                    {fullBodyMaterials.length}
                  </span>
                </div>
                <div className="organ-menu-list">
                  {fullBodyMaterials.map((entry, index) => (
                    <div
                      key={`${entry.name}-${index}`}
                      className={`organ-menu-row${entry.visible ? "" : " is-hidden"}`}
                    >
                      <span
                        className={`organ-menu-dot organ-menu-dot-${index % 8}`}
                        aria-hidden="true"
                      />
                      <span className="organ-menu-label" title={entry.label}>
                        {entry.label}
                      </span>
                      <button
                        type="button"
                        role="switch"
                        className={`organ-menu-switch${entry.visible ? " is-visible" : ""}`}
                        aria-label={`Show ${entry.label}`}
                        aria-checked={entry.visible}
                        onClick={() =>
                          setOrganVisibility(index, !entry.visible)
                        }
                      />
                    </div>
                  ))}
                </div>
                <div className="organ-menu-footer">
                  <span>
                    {fullBodyMaterials.filter((entry) => entry.visible).length} of{" "}
                    {fullBodyMaterials.length} visible
                  </span>
                  <button
                    type="button"
                    className="organ-menu-toggle-all"
                    onClick={() => {
                      const showAll = fullBodyMaterials.some(
                        (entry) => !entry.visible
                      );
                      fullBodyMaterials.forEach(({ material, baseColor, alphaMode }) => {
                        material.setAlphaMode(showAll ? alphaMode : "BLEND");
                        material.pbrMetallicRoughness.setBaseColorFactor([
                          ...baseColor.slice(0, 3),
                          showAll ? baseColor[3] : 0
                        ]);
                      });
                      setFullBodyMaterials((materials) =>
                        materials.map((entry) => ({
                          ...entry,
                          visible: showAll
                        }))
                      );
                    }}
                  >
                    {fullBodyMaterials.every((entry) => entry.visible)
                      ? "Hide all"
                      : "Show all"}
                  </button>
                </div>
              </div>
            </div>
          )}
          {modelSwitchError && (
            <div
              role="alert"
              className="alert alert-danger position-absolute bottom-0 start-50 translate-middle-x mb-3"
              style={{ zIndex: 3 }}
            >
              {modelSwitchError}
            </div>
          )}
        </div>
      {isModelSwitching && (
        <div
          role="status"
          aria-live="polite"
          style={{
            position: "absolute",
            inset: 0,
            zIndex: 31,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            gap: "0.75rem",
            color: "#115256",
            backgroundColor: "rgba(128, 128, 128, 0.3)"
          }}
        >
          <span
            className="dashboard-model-loading-spinner"
            aria-hidden="true"
          />
          <span>
            {isModelAnimating
              ? "Switching model..."
              : `${Math.trunc(modelLoadProgress * 100)}%`}
          </span>
        </div>
      )}
      </main>
      <Footer />
    </div>
  );
}

export default Dashboard;
